class BaseRemovalsApiParms {
  constructor(filters) {
    this.selections = filters.map(item => {
      return {
        id: item.id,
        summaryFilters: item.selection,
        detailFilters: item.selectedItems,
      }
    })
  }

  getFieldGivenId(id) {
    const [first] = this.selections.filter(item => item.id === id)
    return first || null
  }

  getFirstDetailFilter(id, prop) {
    const field = this.getFieldGivenId(id)
    if (field.detailFilters) {
      const filters = field.detailFilters
      return filters.length > 0 ? filters[0][prop] : null
    }
    return null
  }

  getSummaryFilter(id) {
    const field = this.getFieldGivenId(id)
    const filters = field.summaryFilters
    return filters
  }

  getArrayDetailFiltersGivenProp(id, prop) {
    const field = this.getFieldGivenId(id)
    const filters = field.detailFilters
    const items = filters.map(item => item[prop])
    return items
  }

  getArrayDetailFilters(id) {
    const field = this.getFieldGivenId(id)
    const filters = field.detailFilters
    return filters
  }

  getStartDateSummaryFilter(id) {
    const filters = this.getSummaryFilter(id)
    return filters.dates.startDate
  }

  getEndDateSummaryFilter(id) {
    const filters = this.getSummaryFilter(id)
    return filters.dates.endDate
  }
}

export class Removals extends BaseRemovalsApiParms {
  getSelector() {
    const startDate = this.getStartDateSummaryFilter('dates')
    const endDate = this.getEndDateSummaryFilter('dates')

    return {
      tailName: this.getFirstDetailFilter('tail', 'text'),
      startDate,
      endDate,
    }
  }
}
